import { render, staticRenderFns } from "./VideoPublisher.vue?vue&type=template&id=6e56f0fe&scoped=true&"
import script from "./VideoPublisher.vue?vue&type=script&lang=js&"
export * from "./VideoPublisher.vue?vue&type=script&lang=js&"
import style0 from "./VideoPublisher.vue?vue&type=style&index=0&id=6e56f0fe&scoped=true&lang=css&"
import style1 from "./VideoPublisher.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e56f0fe",
  null
  
)

export default component.exports